// extracted by mini-css-extract-plugin
export default {"recorLinks":"index_recorLinks_wqUNL","linksUl":"index_linksUl_l54ms"};